import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AutoFocusModule } from 'primeng/autofocus';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PasswordModule } from 'primeng/password';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { SwiperModule } from 'swiper/angular';
import { AbstractDebounceDirective } from './directives/abstract-debounce.directive';
import { DebounceKeyupDirective } from './directives/debounce-keyup.directive';
import { FcCurrencyPipe } from './pipes/fc-currency.pipe';

@NgModule({
  declarations: [
    FcCurrencyPipe,
    AbstractDebounceDirective,
    DebounceKeyupDirective,
    FcCurrencyPipe,
  ],
  imports: [CommonModule],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    ButtonModule,
    TableModule,
    InputTextModule,
    InputNumberModule,
    CalendarModule,
    BadgeModule,
    DropdownModule,
    ChipModule,
    OverlayPanelModule,
    DynamicDialogModule,
    FcCurrencyPipe,
    CheckboxModule,
    PasswordModule,
    ConfirmDialogModule,
    CardModule,
    SkeletonModule,
    DebounceKeyupDirective,
    SidebarModule,
    FileUploadModule,
    ImageModule,
    AutoFocusModule,
    DialogModule,
    ButtonModule,
    SwiperModule,
  ],
  providers: [DialogService, FcCurrencyPipe],
})
export class SharedModule {}
